// @flow
import React, { Component, type Node } from 'react';

import { mergeClassNames } from 'utils/functions';

type ContainerProps = {
    /** will be appended to the classes */
    className: string,
    /** sets default 'container' class to 'container-fluid' */
    fluid: bool,
    /** If set, will be 100% up to this breakpoint **/
    breakpoint: 'sm' | 'md' | 'lg' | 'xl' | '',
    /** what will be rendered inside the container */
    children: Node
}

/** A structural component for a Container. */
export class Container extends Component<ContainerProps> {

    static defaultProps = {
        fluid: false,
        className: '',
        breakpoint: '',
    };

    render() {

        let { className, breakpoint, fluid, children, ...domProps } = this.props;

        let suffix = '';
        if (breakpoint) {
            suffix = breakpoint;
        } else if (fluid) {
            suffix = 'fluid';
        }

        const containerClass = suffix ? `container-${suffix}` : 'container';

        className = mergeClassNames(containerClass, this.props.className);

        return <div className={className} {...domProps}>{children}</div>;
    }
}

export default Container;
